module.exports = __webpack_public_path__ + "static/Dichtung-PIO-8ff0227f7ff5bd94eafa5b456cafa1cd.jpg";